import CityPageTemplate from "../city-template/CityPageTemplate";
import { chesapeakeVaConfig } from "./data";

export default function ChesapeakeVaPage() {
  return <CityPageTemplate config={chesapeakeVaConfig} />;
}